export const LOADING = 'claims/LOADING';
export const GET_CLAIMS = 'claims/GET_CLAIMS';
export const ADD_CLAIM_SUCCESS = 'claims/ADD_CLAIM_SUCCESS';
export const SUBMIT_LOADING = 'claims/SUBMIT_LOADING';